import * as React from "react";
import {PremiumType, UPFRONT_PAYMENT_THRESHOLD} from "@falcon/services";
import {MtaSuccessModalWording} from "../../../../common/modal/MtaSuccessModalWording";
import {IFactors} from "../../../../common/modal/GeneratorInputTypes";
import {EditCarMtaSuccessModalWordingGenerator} from "./EditCarMtaSuccessModalWordingGenerator";
import * as successModals from "../../../../../../components/modals/SuccessModalRenderers";

export interface IUiState {
    payFullPrice: boolean,
    removedDriverFullName: string;
}

export interface IDriver {
    firstName: string,
    lastName: string;
}

export class EditDriverMtaSuccessModalWordingGenerator {

    public static readonly generateModalWording = (factors: IFactors, driver: IDriver, payFullPrice: boolean, cardNumber: string, agreeToReuseCardDetails: boolean, previousMonthlyPremium: any, instalmentsNotPaidOff: boolean): MtaSuccessModalWording => {

        const premiumType: PremiumType = PremiumType[factors.premiumType as keyof typeof PremiumType];

        let modalTitle: React.ReactNode;
        let modalBody: React.ReactNode;

        if (factors.additionalPremium > 0 && (premiumType === PremiumType.annual || payFullPrice)) {
            modalTitle = "Payment was successful";
            const modalBodyContent = (
                <>
                    for <span
                    className="font-weight-semi-bold">changing {driver.firstName} {driver.lastName}'s details.</span>
                </>
            );
            modalBody = successModals.paymentSuccessfulAdditionalPremiumModal(factors.additionalPremium, cardNumber, modalBodyContent, agreeToReuseCardDetails);
        } else if (factors.additionalPremium > 0 && factors.upfrontPaymentAmount >= UPFRONT_PAYMENT_THRESHOLD && !payFullPrice) {
            modalTitle = "Payment was successful";
            const modalContent = (
                <>
                    for <span
                    className="font-weight-semi-bold">changing {driver.firstName} {driver.lastName}'s details.</span>
                </>
            )
            modalBody = successModals.paymentSuccessfulAdditionalPremiumMonthlyModal(factors.upfrontPaymentAmount, factors.monthlyPaymentSpreadAmount, cardNumber, modalContent, agreeToReuseCardDetails);
        } else if (factors.additionalPremium > 0 && factors.upfrontPaymentAmount < UPFRONT_PAYMENT_THRESHOLD && !payFullPrice) {
            modalTitle = "Your payment plan has been updated";
            modalBody = successModals.paymentPlanUpdatedAdditionalPremiumModal(factors, previousMonthlyPremium);
        } else if (factors.returnPremium > 0 && premiumType === PremiumType.monthly && factors.monthlyPremium !== 0) {
            if (instalmentsNotPaidOff) {
                modalTitle = "Your payment plan has been updated";
            } else {
                modalTitle = "Your refund is on the way";
            }
            modalBody = successModals.paymentPlanUpdatedRefundModal(factors.returnPremium, factors.monthlyPremium, previousMonthlyPremium, instalmentsNotPaidOff);
        } else if (factors.returnPremium > 0) {
            modalTitle = "Your Refund is on the way";
            const modalContent = (
                <>
                    <span
                        className="font-weight-semi-bold">for changing {driver.firstName} {driver.lastName}'s details.</span>
                </>
            )
            modalBody = successModals.paymentSuccessfulRefundModal(factors.returnPremium, modalContent);
        } else {
            modalTitle = "All done";
            modalBody = (
                <p className="font-weight-extra-light">
                    We’ve saved your changes, and there’s no extra cost for{" "}
                    <span
                        className="font-weight-semi-bold">changing {driver.firstName} {driver.lastName}'s details.</span>
                </p>
            );
        }

        return new MtaSuccessModalWording(modalTitle, modalBody, EditCarMtaSuccessModalWordingGenerator.generateAnythingElseChangedModalTitle(), EditCarMtaSuccessModalWordingGenerator.generateAnythingElseChangedModalBody());
    }

}
